module.exports = __webpack_public_path__ + "img/USDC.5e46b76a.png";